export const DEMO_CURRENCY = 'CNY'
